import React from 'react';
import { Box, styled } from '@mui/material';

export type ProgressBarProps = {
  progress?: string;
}

const ProgressBarWrapperStyled = styled(Box)<ProgressBarProps>(({ theme }) => ({
  width: '100%',
  height: '10px',
  position: 'fixed',
  background: theme.palette.background.default,
  top: 0,
  left: 0,
  zIndex: 999,
}));

const ProgressBarStyled = styled(Box, {
  shouldForwardProp: (propName: string) => propName !== 'progress',
})<ProgressBarProps>(({ theme, progress }) => ({
  width: progress,
  height: '100%',
  transition: '0.25s ease width',
  background: theme.palette.success.main,
}));


function ProgressBar({ progress = '0%' }: ProgressBarProps) {
  return (
    <ProgressBarWrapperStyled>
      <ProgressBarStyled progress={progress} />
    </ProgressBarWrapperStyled>
  );
}

export default ProgressBar;
